var _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgCf1(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 48,
    height: 48,
    viewBox: "0 0 48 48",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_628",
    "data-name": "Group 628",
    transform: "translate(-494 -1003)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Rectangle_131",
    "data-name": "Rectangle 131",
    transform: "translate(494 1003)",
    fill: "#fff",
    stroke: "#707070",
    strokeWidth: 1,
    opacity: 0
  }, /*#__PURE__*/React.createElement("rect", {
    width: 48,
    height: 48,
    stroke: "none"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 0.5,
    y: 0.5,
    width: 47,
    height: 47,
    fill: "none"
  })), /*#__PURE__*/React.createElement("g", {
    id: "student_1_",
    "data-name": "student (1)",
    transform: "translate(468.257 1000.003)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_527",
    "data-name": "Path 527",
    d: "M84.565,197.354H73.545a4.571,4.571,0,0,0-4.571,4.571v4.15H89.136v-4.15A4.571,4.571,0,0,0,84.565,197.354Z",
    transform: "translate(-29.163 -158.401)",
    fill: "#e0ebfc"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_528",
    "data-name": "Path 528",
    d: "M87.481,204.768H67.318a.345.345,0,0,1-.344-.344v-4.15a4.921,4.921,0,0,1,4.916-4.916h.643a.345.345,0,0,1,.292.162l2.333,3.733,1.943-3.318a.345.345,0,0,1,.594,0l1.943,3.318,2.333-3.733a.345.345,0,0,1,.292-.162h.645a4.921,4.921,0,0,1,4.916,4.916v4.15A.345.345,0,0,1,87.481,204.768Zm-19.818-.689H87.136v-3.806a4.232,4.232,0,0,0-4.227-4.227h-.454L79.922,200.1a.345.345,0,0,1-.292.162h0a.345.345,0,0,1-.292-.17l-1.934-3.3-1.934,3.3a.344.344,0,0,1-.292.17.357.357,0,0,1-.3-.162l-2.534-4.053H71.89a4.232,4.232,0,0,0-4.227,4.227v3.806Z",
    transform: "translate(-27.508 -156.749)",
    fill: "#3762cc"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_529",
    "data-name": "Path 529",
    d: "M99.532,190.744l-.278.88,2.635,4.215,2.231-3.81-4-1.567A.448.448,0,0,0,99.532,190.744Z",
    transform: "translate(-54.228 -152.671)",
    fill: "#e0ebfc"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_530",
    "data-name": "Path 530",
    d: "M132.092,190.744l.278.88-2.635,4.215-2.231-3.81,4-1.567A.448.448,0,0,1,132.092,190.744Z",
    transform: "translate(-77.613 -152.671)",
    fill: "#e0ebfc"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_531",
    "data-name": "Path 531",
    d: "M100.233,194.529a.344.344,0,0,1-.292-.162l-2.635-4.215a.344.344,0,0,1-.036-.286l.278-.88a.793.793,0,0,1,1.045-.5l4,1.567a.344.344,0,0,1,.172.495l-2.231,3.81a.344.344,0,0,1-.292.17Zm-2.259-4.607,2.249,3.6,1.74-2.971-3.623-1.42a.1.1,0,0,0-.082,0,.1.1,0,0,0-.054.062Z",
    transform: "translate(-52.573 -151.017)",
    fill: "#3762cc"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_532",
    "data-name": "Path 532",
    d: "M128.08,194.529h0a.345.345,0,0,1-.292-.17l-2.231-3.81a.344.344,0,0,1,.172-.495l4-1.567a.792.792,0,0,1,1.045.5l.278.88a.345.345,0,0,1-.036.286l-2.635,4.215A.345.345,0,0,1,128.08,194.529Zm-1.73-3.981,1.74,2.971,2.249-3.6-.23-.728h0a.1.1,0,0,0-.054-.062.1.1,0,0,0-.083,0Z",
    transform: "translate(-75.958 -151.016)",
    fill: "#3762cc"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_533",
    "data-name": "Path 533",
    d: "M127.5,197.357v0l0,0Z",
    transform: "translate(-77.613 -158.404)",
    fill: "#4671c6"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_534",
    "data-name": "Path 534",
    d: "M86,202.367H82.8a.344.344,0,0,1-.256-.114l-6.939-7.7a.689.689,0,0,1,.3-1.116l2.913-.95a.688.688,0,0,1,.8.289l4.787,7.652,4.787-7.652a.688.688,0,0,1,.8-.29l2.912.95a.689.689,0,0,1,.3,1.116l-6.939,7.7a.343.343,0,0,1-.256.114Zm-3.048-.689h2.9L92.68,194.1l-2.912-.95-4.9,7.834a.551.551,0,0,1-.469.26h0a.55.55,0,0,1-.468-.26h0l-4.9-7.835-2.912.95Z",
    transform: "translate(-34.502 -154.348)",
    fill: "#3762cc"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_535",
    "data-name": "Path 535",
    d: "M104.694,194.529h0a.345.345,0,0,1-.292-.17l-1.934-3.3-1.934,3.3a.344.344,0,0,1-.292.17.357.357,0,0,1-.3-.162l-2.635-4.215a.344.344,0,0,1-.036-.286l.278-.88a.793.793,0,0,1,1.045-.5L102.463,190l3.871-1.518a.792.792,0,0,1,1.045.5l.278.88a.345.345,0,0,1-.036.286l-2.635,4.215a.344.344,0,0,1-.292.162Zm-6.72-4.607,2.249,3.6,1.74-2.971-3.623-1.42a.1.1,0,0,0-.082,0,.1.1,0,0,0-.054.062Zm4.99.627,1.74,2.971,2.249-3.6-.23-.728a.1.1,0,0,0-.136-.065Z",
    transform: "translate(-52.572 -151.016)",
    fill: "#3762cc"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_536",
    "data-name": "Path 536",
    d: "M103.962,187.025l4,1.567,4-1.567a.432.432,0,0,1,.068-.019v-.725a8.827,8.827,0,0,1-8.133,0v.727A.411.411,0,0,1,103.962,187.025Z",
    transform: "translate(-58.068 -149.234)",
    fill: "#f9cfcf"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_537",
    "data-name": "Path 537",
    d: "M106.3,187.279a.344.344,0,0,1-.126-.024l-4.012-1.57a.345.345,0,0,1-.274-.337v-.727a.344.344,0,0,1,.5-.305,8.482,8.482,0,0,0,7.814,0,.345.345,0,0,1,.5.306v.725a.344.344,0,0,1-.27.336l-.023.005-3.992,1.565A.347.347,0,0,1,106.3,187.279Zm-2.281-1.609,2.281.894,2.275-.892A9.251,9.251,0,0,1,104.023,185.67Zm-1.837.02h0Z",
    transform: "translate(-56.413 -147.577)",
    fill: "#3762cc"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_538",
    "data-name": "Path 538",
    d: "M81.069,101.964C79.492,100.829,78,100.008,77.58,97.7a14.235,14.235,0,0,1-6.8,2.855s-.785.1-1.185.138a12.045,12.045,0,0,1-5.96-.778,8.679,8.679,0,0,0-.09,1.234v.82l-.055,0a2.649,2.649,0,1,0,0,5.3,2.718,2.718,0,0,0,.287-.016,8.777,8.777,0,0,0,17.057,0,2.717,2.717,0,0,0,.287.016,2.648,2.648,0,1,0-.055-5.294Z",
    transform: "translate(-22.414 -75.907)",
    fill: "#f9ebcf"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_405",
    "data-name": "Group 405",
    transform: "translate(44.503 26.946)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_539",
    "data-name": "Path 539",
    d: "M117.856,158.974a2.2,2.2,0,0,1-1.565-.606,1.478,1.478,0,0,1-.449-1.038.344.344,0,1,1,.689,0,.785.785,0,0,0,.25.553,1.534,1.534,0,0,0,1.076.4,1.5,1.5,0,0,0,1.069-.4.785.785,0,0,0,.25-.553.344.344,0,1,1,.689,0,1.477,1.477,0,0,1-.45,1.038A2.194,2.194,0,0,1,117.856,158.974Z",
    transform: "translate(-112.463 -151.932)",
    fill: "#3762cc"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_540",
    "data-name": "Path 540",
    d: "M97.28,131.517a1.059,1.059,0,0,1-1.058-1.057V128.7a1.058,1.058,0,0,1,2.115,0v1.763A1.059,1.059,0,0,1,97.28,131.517Z",
    transform: "translate(-96.222 -127.64)",
    fill: "#3762cc"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_541",
    "data-name": "Path 541",
    d: "M147.592,131.517a1.059,1.059,0,0,1-1.058-1.057V128.7a1.058,1.058,0,0,1,2.115,0v1.763A1.059,1.059,0,0,1,147.592,131.517Z",
    transform: "translate(-137.869 -127.64)",
    fill: "#3762cc"
  })), /*#__PURE__*/React.createElement("path", {
    id: "Path_542",
    "data-name": "Path 542",
    d: "M76.294,59.844a9.4,9.4,0,0,0-7.314-1.8c-5.052.245-8.856,4.385-9.827,5.545a1.9,1.9,0,0,0-.242.3.5.5,0,0,0,.023.438c.572,1.026,2.777,3.968,9.05,3.43.4-.034,1.185-.138,1.185-.138,3.038-.385,8.313-2.55,8.263-5.578A2.787,2.787,0,0,0,76.294,59.844Z",
    transform: "translate(-20.801 -42.976)",
    fill: "#4671c6"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_543",
    "data-name": "Path 543",
    d: "M64.873,66.51c-5.4,0-7.388-2.763-7.894-3.671a.841.841,0,0,1-.04-.738,1.845,1.845,0,0,1,.3-.4c1.068-1.275,4.913-5.4,10.049-5.658a9.737,9.737,0,0,1,7.554,1.867h0a3.122,3.122,0,0,1,1.278,2.469c.055,3.371-5.644,5.555-8.564,5.925-.031,0-.8.1-1.2.139C65.837,66.489,65.342,66.51,64.873,66.51Zm-7.3-4.13a.153.153,0,0,0,.012.123c.5.9,2.606,3.779,8.719,3.255.388-.033,1.162-.135,1.17-.136,2.884-.366,8.01-2.426,7.963-5.23a2.437,2.437,0,0,0-1-1.927h0a9.072,9.072,0,0,0-7.055-1.736l-.037,0c-4.877.236-8.565,4.21-9.58,5.422l-.022.023a2.433,2.433,0,0,0-.172.2Zm.005-.014Z",
    transform: "translate(-19.145 -41.32)",
    fill: "#3762cc"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_544",
    "data-name": "Path 544",
    d: "M161.456,76.953a1.617,1.617,0,0,0-1.981-.363,2.759,2.759,0,0,1,.123.758,3.65,3.65,0,0,1-1.466,2.723c.419,2.319,1.939,3.153,3.489,4.268a2.649,2.649,0,0,1,1.333.319l.186-1.363A8.53,8.53,0,0,0,161.456,76.953Z",
    transform: "translate(-102.966 -58.282)",
    fill: "#4671c6"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_545",
    "data-name": "Path 545",
    d: "M161.3,83.359a.345.345,0,0,1-.164-.041,2.333,2.333,0,0,0-1.162-.278.332.332,0,0,1-.209-.065c-.16-.115-.319-.227-.477-.338-1.414-.993-2.749-1.931-3.149-4.149a.344.344,0,0,1,.112-.32,3.292,3.292,0,0,0,1.349-2.458,2.427,2.427,0,0,0-.109-.664.345.345,0,0,1,.23-.43l.086-.027a1.892,1.892,0,0,1,2.269.51,8.929,8.929,0,0,1,1.751,6.6l-.186,1.363a.344.344,0,0,1-.185.261A.348.348,0,0,1,161.3,83.359Zm-1.223-1.009a2.978,2.978,0,0,1,.944.165l.124-.91a8.236,8.236,0,0,0-1.616-6.087,1.081,1.081,0,0,0-1.3-.338,2.986,2.986,0,0,1,.055.517,3.83,3.83,0,0,1-1.435,2.854c.39,1.807,1.524,2.6,2.831,3.521Z",
    transform: "translate(-101.311 -56.637)",
    fill: "#3762cc"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_546",
    "data-name": "Path 546",
    d: "M65.746,103.507a8.488,8.488,0,0,0,.007,2.224l.209,1.535a2.674,2.674,0,0,1,1.55-.494l.055,0v-.82a8.647,8.647,0,0,1,.091-1.233A7.225,7.225,0,0,1,65.746,103.507Z",
    transform: "translate(-26.434 -80.717)",
    fill: "#4671c6"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_547",
    "data-name": "Path 547",
    d: "M64.306,105.955a.344.344,0,0,1-.341-.3l-.209-1.535a8.851,8.851,0,0,1-.007-2.314.344.344,0,0,1,.571-.213,6.907,6.907,0,0,0,1.823,1.156.344.344,0,0,1,.2.364,8.345,8.345,0,0,0-.087,1.184v.82a.345.345,0,0,1-.1.247.334.334,0,0,1-.25.1l-.04,0h0a2.327,2.327,0,0,0-1.355.43A.345.345,0,0,1,64.306,105.955Zm.07-3.429a8.1,8.1,0,0,0,.063,1.5l.14,1.026a3,3,0,0,1,.99-.27V104.3a8.877,8.877,0,0,1,.061-1.026,7.757,7.757,0,0,1-1.253-.747Z",
    transform: "translate(-24.778 -79.062)",
    fill: "#3762cc"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_548",
    "data-name": "Path 548",
    d: "M206.406,99.649h-2.3a.265.265,0,0,1-.265-.265V97.071a1.411,1.411,0,0,1,1.41-1.41h.005a1.411,1.411,0,0,1,1.41,1.41v2.313a.265.265,0,0,1-.265.265Z",
    transform: "translate(-140.807 -74.222)",
    fill: "#6bdddd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_549",
    "data-name": "Path 549",
    d: "M208.722,51.458h.005a1.4,1.4,0,0,1,.689.181V42.955a.692.692,0,1,0-1.384,0v8.684A1.4,1.4,0,0,1,208.722,51.458Z",
    transform: "translate(-144.274 -30.019)",
    fill: "#6bdddd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_550",
    "data-name": "Path 550",
    d: "M204.752,98.339h-2.3a.61.61,0,0,1-.609-.609V95.417a1.757,1.757,0,0,1,3.515,0V97.73A.61.61,0,0,1,204.752,98.339Zm-2.217-.689h2.137V95.417a1.069,1.069,0,0,0-2.137,0Z",
    transform: "translate(-139.152 -72.568)",
    fill: "#3762cc"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_551",
    "data-name": "Path 551",
    d: "M207.762,50.327a.344.344,0,0,1-.169-.044,1.065,1.065,0,0,0-.521-.137h-.005a1.064,1.064,0,0,0-.521.137.345.345,0,0,1-.513-.3V41.3a1.037,1.037,0,1,1,2.073,0v8.684a.345.345,0,0,1-.17.3.349.349,0,0,1-.175.047Zm-.695-.87h.005a1.741,1.741,0,0,1,.345.034V41.3a.348.348,0,1,0-.7,0v8.193A1.745,1.745,0,0,1,207.068,49.458Z",
    transform: "translate(-142.619 -28.363)",
    fill: "#3762cc"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_552",
    "data-name": "Path 552",
    d: "M50.681,8.116,36.255,13.9a.828.828,0,0,0,.02,1.537l14.446,5.353a1.613,1.613,0,0,0,1.121,0l14.45-5.355a.826.826,0,0,0,.02-1.534L51.883,8.116a1.612,1.612,0,0,0-1.2,0Z",
    transform: "translate(-1.657 -1.658)",
    fill: "#4671c6"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_553",
    "data-name": "Path 553",
    d: "M49.625,19.579a1.955,1.955,0,0,1-.68-.122L34.5,14.1a1.172,1.172,0,0,1-.028-2.18L48.9,6.138a1.952,1.952,0,0,1,1.458,0l14.43,5.789a1.17,1.17,0,0,1-.028,2.176l-14.45,5.355A1.959,1.959,0,0,1,49.625,19.579Zm-.473-12.8L34.727,12.564a.483.483,0,0,0,.011.894l14.446,5.353a1.272,1.272,0,0,0,.882,0l14.45-5.355a.481.481,0,0,0,.011-.891L50.1,6.777a1.263,1.263,0,0,0-.945,0Z",
    transform: "translate(0 0)",
    fill: "#3762cc"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_554",
    "data-name": "Path 554",
    d: "M87.772,50.128a51.971,51.971,0,0,0-18.12,0c-.317.064-.522.224-.522.4v3.991h0c0,.181.219.343.552.4a51.971,51.971,0,0,0,18.12,0c.227-.046.522-.175.522-.407V50.531h0C88.324,50.349,88.1,50.188,87.772,50.128Z",
    transform: "translate(-29.292 -35.858)",
    fill: "#4671c6"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_555",
    "data-name": "Path 555",
    d: "M77.469,54.414a55.509,55.509,0,0,1-9.5-.819c-.508-.092-.835-.383-.835-.742V48.87c0-.358.313-.647.8-.744a52.218,52.218,0,0,1,18.25,0c.507.092.835.383.835.742v3.983c0,.36-.306.645-.8.744a44.578,44.578,0,0,1-8.745.816Zm-9.651-1.6a.61.61,0,0,0,.269.1,51.492,51.492,0,0,0,17.991,0,.61.61,0,0,0,.246-.1V48.909a.607.607,0,0,0-.269-.1h0a51.477,51.477,0,0,0-17.991,0,.572.572,0,0,0-.246.1Zm18.519-3.893h0Z",
    transform: "translate(-27.636 -34.198)",
    fill: "#3762cc"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_556",
    "data-name": "Path 556",
    d: "M70.652,112.635a9.048,9.048,0,0,1-8.793-6.687h-.022a2.992,2.992,0,0,1-.289-5.972v-.487a9.054,9.054,0,0,1,.093-1.283.345.345,0,0,1,.48-.266,11.828,11.828,0,0,0,5.791.75c.388-.033,1.162-.135,1.17-.136A13.886,13.886,0,0,0,75.7,95.782a.345.345,0,0,1,.566.2c.35,1.936,1.516,2.757,2.867,3.707q.2.137.394.278a3,3,0,0,1,2.065.861,2.958,2.958,0,0,1,.9,2.129,3.008,3.008,0,0,1-3.017,2.993h-.022a9.048,9.048,0,0,1-8.793,6.687Zm-8.528-7.391a.344.344,0,0,1,.335.266,8.433,8.433,0,0,0,16.387,0,.346.346,0,0,1,.371-.264,2.357,2.357,0,0,0,.25.014,2.319,2.319,0,0,0,2.328-2.3,2.313,2.313,0,0,0-2.376-2.3.375.375,0,0,1-.209-.065c-.161-.116-.32-.228-.478-.339-1.289-.907-2.514-1.768-3.022-3.593a15.17,15.17,0,0,1-6.541,2.58c-.031,0-.8.1-1.2.139a12.938,12.938,0,0,1-5.7-.631c-.023.25-.034.5-.034.743v.82a.345.345,0,0,1-.351.344l-.043,0h0a2.3,2.3,0,1,0,0,4.608,2.365,2.365,0,0,0,.251-.014Z",
    transform: "translate(-20.758 -74.252)",
    fill: "#3762cc"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_557",
    "data-name": "Path 557",
    d: "M121.537,221.14h-1.912l-.486,1.377,1.267,2.024a.207.207,0,0,0,.343.014l1.274-2.037Z",
    transform: "translate(-70.69 -178.092)",
    fill: "#6bdddd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_558",
    "data-name": "Path 558",
    d: "M73.578,204.854a.209.209,0,0,1-.355,0l-.123-.2-4.569-7.3h-.444a5.946,5.946,0,0,0-5.946,5.946v2.776H84.655V203.3a5.946,5.946,0,0,0-5.946-5.946h-.444L75.987,201Z",
    transform: "translate(-23.507 -158.404)",
    fill: "#4671c6"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_559",
    "data-name": "Path 559",
    d: "M83,204.768H60.485a.345.345,0,0,1-.344-.344v-2.775a6.3,6.3,0,0,1,6.291-6.291h.445a.344.344,0,0,1,.292.162l4.577,7.314,4.572-7.314a.344.344,0,0,1,.292-.162h.444a6.3,6.3,0,0,1,6.291,6.291v2.775A.344.344,0,0,1,83,204.768ZM60.83,204.08H82.654v-2.431a5.608,5.608,0,0,0-5.6-5.6H76.8l-4.585,7.335h0a.551.551,0,0,1-.469.26h0a.55.55,0,0,1-.468-.26l-4.59-7.335h-.254a5.608,5.608,0,0,0-5.6,5.6Zm11.092-.88h0Z",
    transform: "translate(-21.851 -156.75)",
    fill: "#3762cc"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_560",
    "data-name": "Path 560",
    d: "M85.876,202.454l-4.9-7.834a.344.344,0,0,0-.4-.145l-2.912.95a.344.344,0,0,0-.149.558l6.939,7.7h3.2l6.939-7.7a.345.345,0,0,0-.149-.558l-2.912-.95a.345.345,0,0,0-.4.145l-4.9,7.834a.21.21,0,0,1-.355,0Z",
    transform: "translate(-36.159 -156.005)",
    fill: "#f9a7a7"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_561",
    "data-name": "Path 561",
    d: "M86,202.367H82.8a.344.344,0,0,1-.256-.114l-6.939-7.7a.689.689,0,0,1,.3-1.116l2.913-.95a.688.688,0,0,1,.8.289l4.787,7.652,4.787-7.652a.688.688,0,0,1,.8-.29l2.912.95a.689.689,0,0,1,.3,1.116l-6.939,7.7a.343.343,0,0,1-.256.114Zm-3.048-.689h2.9L92.68,194.1l-2.912-.95-4.9,7.834a.551.551,0,0,1-.469.26h0a.55.55,0,0,1-.468-.26h0l-4.9-7.835-2.912.95Z",
    transform: "translate(-34.502 -154.348)",
    fill: "#3762cc"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_562",
    "data-name": "Path 562",
    d: "M120.266,199.711l-1.507,2.588.551,1.1h1.912l.552-1.1Z",
    transform: "translate(-70.374 -160.353)",
    fill: "#6bdddd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_563",
    "data-name": "Path 563",
    d: "M119.567,202.092h-1.912a.345.345,0,0,1-.308-.19l-.551-1.1a.345.345,0,0,1,.011-.327l1.507-2.588a.345.345,0,0,1,.6,0l1.508,2.59a.345.345,0,0,1,.01.328l-.552,1.1A.345.345,0,0,1,119.567,202.092Zm-1.7-.689h1.486l.373-.744-1.117-1.918-1.116,1.916Z",
    transform: "translate(-68.719 -158.699)",
    fill: "#3762cc"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_564",
    "data-name": "Path 564",
    d: "M118.929,223.327h0a.55.55,0,0,1-.468-.26l-1.267-2.025a.344.344,0,0,1-.033-.3l.486-1.377a.344.344,0,0,1,.325-.23h1.912a.344.344,0,0,1,.325.23l.486,1.379a.344.344,0,0,1-.033.3l-1.274,2.037a.231.231,0,0,1-.018.025A.556.556,0,0,1,118.929,223.327Zm-1.064-2.509,1.063,1.7,1.061-1.7-.35-.992h-1.424Z",
    transform: "translate(-69.034 -176.435)",
    fill: "#3762cc"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgCf1);
export default __webpack_public_path__ + "static/media/cf1.fb69a1ada323d0cd747eb3dcc591e03f.svg";
export { ForwardRef as ReactComponent };